<div class="invoices-container">
  <!-- Buscador por teléfono -->
  <mat-card class="mb-25 tagus-card search-card">
    <mat-card-content>
      <div class="search-row">
        <mat-form-field appearance="outline" class="search-field">
          <mat-label>Número de teléfono</mat-label>
          <input
            matInput
            [(ngModel)]="searchPhone"
            placeholder="Ej: 573001234567"
            (keyup.enter)="searchByPhone()"
          />
          <mat-icon matPrefix>phone</mat-icon>
        </mat-form-field>
        <button
          mat-flat-button
          class="default-btn bg-color-blue-button search-btn"
          (click)="searchByPhone()"
        >
          <mat-icon>search</mat-icon> Buscar
        </button>
      </div>
    </mat-card-content>
  </mat-card>

  <!-- Tabla de resultados -->
  <mat-card class="mb-25 tagus-card" *ngIf="currentPhone">
    <mat-card-header>
      <h5 class="mb-0 title-color">
        Facturas de {{ currentPhone }}
        <span class="total-badge">{{ totalItems }}</span>
      </h5>
    </mat-card-header>
    <mat-card-content>
      <div
        class="teamMembersListTable tagus-mat-table mat-elevation-z8"
        *ngIf="listInvoices.length > 0; else noResults"
      >
        <table mat-table [dataSource]="dataSource" class="table-responsive">
          <!-- Código -->
          <ng-container matColumnDef="invoiceCode">
            <th mat-header-cell *matHeaderCellDef>Código</th>
            <td mat-cell *matCellDef="let element">
              {{ element.invoiceCode }}
            </td>
          </ng-container>

          <!-- Tipo -->
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef>Tipo</th>
            <td mat-cell *matCellDef="let element">
              <span
                class="badgea fw-medium"
                [ngClass]="{
                  'badge-factura': element.type === 'factura',
                  'badge-cotizacion': element.type === 'cotizacion',
                }"
              >
                {{ element.type === "factura" ? "Factura" : "Cotización" }}
              </span>
            </td>
          </ng-container>

          <!-- Cliente -->
          <ng-container matColumnDef="clientName">
            <th mat-header-cell *matHeaderCellDef>Cliente</th>
            <td mat-cell *matCellDef="let element">
              {{ element.clientName || "—" }}
            </td>
          </ng-container>

          <!-- Total -->
          <ng-container matColumnDef="grandTotal">
            <th mat-header-cell *matHeaderCellDef>Total</th>
            <td mat-cell *matCellDef="let element" class="total-cell">
              {{ element.grandTotal | number: "1.0-0" }}
            </td>
          </ng-container>

          <!-- Fecha -->
          <ng-container matColumnDef="createdAt">
            <th mat-header-cell *matHeaderCellDef>Fecha</th>
            <td mat-cell *matCellDef="let element">
              {{ element.createdAt | date: "dd/MM/yyyy HH:mm" }}
            </td>
          </ng-container>

          <!-- Acciones -->
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef>Acciones</th>
            <td mat-cell *matCellDef="let element">
              <button
                mat-icon-button
                class="blue-color"
                matTooltip="Descargar PDF"
                (click)="downloadPdf(element)"
              >
                <mat-icon>picture_as_pdf</mat-icon>
              </button>
              <button
                mat-icon-button
                class="blue-color"
                matTooltip="Eliminar"
                (click)="deleteInvoice(element)"
              >
                <mat-icon class="ri-delete-bin-line"></mat-icon>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>

        <mat-paginator
          [length]="totalItems"
          [pageSize]="10"
          [pageSizeOptions]="[10, 20, 50]"
          showFirstLastButtons
        ></mat-paginator>
      </div>

      <ng-template #noResults>
        <div class="no-results">
          <mat-icon>receipt_long</mat-icon>
          <p>No se encontraron facturas para este número.</p>
        </div>
      </ng-template>
    </mat-card-content>
  </mat-card>
</div>
